import axios from 'axios';
import CustomSelect from '../../components/form/custom-select';
import History from '../../components/history';
import newsCardTemplate from '../../components/news/news-card.twig';
import Observer from '../../common/scripts/observer';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

class NewsList {
    constructor() {
        /**
         * Обёртка
         */
        this.wrapper = null;

        /**
         * Адрес для запросов
         * @type {string}
         */
        this.action = '';

        /**
         * Номер следующей страницы для запроса
         * @type {string}
         */
        this.pageNum = '1';

        /**
         * Блок с пустым результатом
         */
        this.emptyBlock = null;

        /**
         * Без активности
         */
        this.noChecked = true;

        /**
         * Кнопка "показать ещё"
         */
        this.moreButton = null;

        /**
         * Обёртка для контента
         */
        this.contentWrapper = null;

        /**
         * Обёртка куда вставляется первая часть новостей
         */
        this.listWrapperFirst = null;

        /**
         * Обёртка куда вставляется вторая часть новостей
         */
        this.listWrapperSecond = null;

        /**
         * Шаблон вывода новостей
         */
        this.template = null;

        /**
         * Обёртка для тегов
         */
        this.tagsWrapper = null;

        /**
         * Теги
         * @type {*[]}
         */
        this.tags = [];

        /**
         * Максимальное кол-во элементов для показа
         * @type {number}
         */
        this.maxShow = 12;

        /**
         * Подгружаем ли доп. новости, true - подгружаем, false - обновляем страницу
         * @type {boolean}
         */
        this.isLoadMore = false;

        /**
         * Класс который добавляется при подгрузке
         * @type {string}
         */
        this.loadingClass = 'is-loading';

        /**
         * Данные с сервера
         */
        this.newsData = null;

        /**
         * Инпут для поиска
         */
        this.inputSearch = null;

        /**
         * Обёртка селектора с датой
         */
        this.selectWrapper = null;
    }

    /**
     * Инициализация компонента
     * @param {object} options - внешние параметры
     */
    init(options) {
        this.wrapper = options.wrapper;

        this._getElements();
        this._initCustomSelect();
        this._bindEvents();
        this._send();
        this._fromRedirect();
    }

    /**
     * Получает основные элементы со страницы
     * @private
     */
    _getElements() {
        this.action = this.wrapper.dataset.action;
        this.pageNum = this.wrapper.dataset.pageNum;
        this.maxShow = Number(this.wrapper.dataset.maxShow) || 12;
        this.promotion = this.wrapper.dataset.promotion || null;

        this.tagsWrapper = this.wrapper.querySelector('.j-news-tags-wrapper');

        if (this.tagsWrapper) {
            this.tags = Array.from(this.tagsWrapper.querySelectorAll('.j-news-tag'));
        }

        this.emptyBlock = this.wrapper.querySelector('.j-news-empty');
        this.contentWrapper = this.wrapper.querySelector('.j-news-content');
        this.inputSearch = this.wrapper.querySelector('.j-news-search');
        this.buttonSearch = this.wrapper.querySelector('.j-news-search-button');
        this.selectWrapper = this.wrapper.querySelector('.j-news-select');

        if (this.contentWrapper) {
            this.moreButton = this.contentWrapper.querySelector('.j-news-more');

            const lists = Array.from(this.contentWrapper.querySelectorAll('.j-news-content-list'));

            this.listWrapperFirst = lists[0] ? lists[0] : null;
            this.listWrapperSecond = lists[1] ? lists[1] : null;
        }

        this.template = newsCardTemplate;
    }

    /**
     * Инициализация кастомных селектов
     * @private
     */
    _initCustomSelect() {
        if (!this.selectWrapper) {
            return;
        }

        this.select = new CustomSelect({
            elem: this.selectWrapper
        });

        this.select.init();
    }

    /**
     * Навешиваем обработчики событий
     * @private
     */
    _bindEvents() {
        this._bindEventsTags();
        this._bindEventsSelect();

        this.inputSearch?.addEventListener('change', () => {
            this.pageNum = '1';
            this._send();
        });

        this.buttonSearch?.addEventListener('click', () => {
            this.inputSearch.blur();
        });

        this.moreButton?.addEventListener('click', () => {
            this.isLoadMore = true;

            this._send();
        });
    }

    _fromRedirect() {
        if (window.location.href.includes('/news/')) {
            const url = new URL(location);

            history.pushState(null, document.title, url.origin + url.pathname);
        }
    }

    /**
     * Навешивает обработчики событий на теги
     * @private
     */
    _bindEventsTags() {
        if (!this.tags.length) {
            return;
        }

        // ищем кнопку "все новости"
        const resetTag = this.tags.find((tag) => {
            return tag.classList.contains('j-news-tag-all');
        });

        // если в гет параметрах есть активный тег, то переключаем this.noChecked
        this.tags.forEach((tag) => {
            if (tag !== resetTag && tag.checked) {
                this.noChecked = false;
            }
        });

        // Если в гет параметрах нет активных тегов и есть кнопка Все новости, но делаем её активной
        if (this.noChecked && resetTag) {
            resetTag.checked = true;
        }

        this.tags.forEach((tag) => {
            tag.addEventListener('change', (event) => {
                if (resetTag) {
                    if (window.location.href.includes('/news/')) {
                        window.location.replace('/news');
                        History.clear();
                    }

                    // если кликнули по кнопке "все новости" когда она была активна, выходим
                    if (!resetTag.checked && tag === resetTag) {
                        event.preventDefault();

                        resetTag.checked = true;

                        return;
                    }

                    this._checkStatusTags(resetTag, tag);
                }

                this.pageNum = '1';
                this.isLoadMore = false;

                this._send('btn');
            });
        });
    }

    /**
     * Привязка событий к селекту
     * @private
     */
    _bindEventsSelect() {
        if (!this.selectWrapper) {
            return;
        }

        this.selectWrapper.addEventListener('change', () => {
            this.pageNum = '1';
            this._send();
        });
    }

    /**
     * Проверяет активные теги и формирует нужную активность
     * @param {object} resetTag - тег "все новости" (сбрасыает другие теги)
     * @param {object} currentTag - тег на который клинкули
     * @private
     */
    _checkStatusTags(resetTag, currentTag) {
        // если кликнули по "все новости", то сбрасываем с друних инпутов активность, а на все "все новости" навешиваем
        // иначе проверяем статусы инпутов
        if (currentTag === resetTag) {
            this.tags.forEach((otherTag) => {
                if (otherTag !== resetTag) {
                    otherTag.checked = false;
                }
            });

            resetTag.checked = true;
        } else {
            resetTag.checked = false;

            const activeInputs = this.tags.filter((item) => {
                return item.checked;
            });

            // если не осталось активных инпутов, активируем "все новости"
            if (!activeInputs.length) {
                resetTag.checked = true;
            }
        }
    }

    /**
     * Метод отправляет данные на сервер.
     * @private
     */

    async _send(type) {
        this.formData = this._collectData();
        this.loadingClass = this.isLoadMore ? 'is-loading' : 'is-update';
        this._startLoading();
        this._disabledTags();

        await axios.post(this.action, this.formData)
            .then((response) => {
                const success = response.data.success;

                // Удаляем параметр page_num из url
                for (const [key] of this.formData) {
                    if (key === 'page_num') {
                        this.formData.delete(key);
                    }
                }

                if (success) {
                    this.newsData = response.data.data;

                    if (type === 'btn' && this.newsData.redirect && !this.newsData.redirect.is_default) {
                        window.location.replace(this.newsData.redirect.redirect_to);
                    }

                    // Добавляем параметры в url
                    // History.replaceFromString(new URLSearchParams(this.formData).toString());

                    History.clear('');
                    if (this.newsData.items.length > 0) {
                        this.emptyBlock.classList.remove('is-active');
                        this._setTemplateData();
                    } else {
                        this.emptyBlock.classList.add('is-active');
                    }
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                this._endLoading();
                this._enabledTags();
            });
    }

    /**
     * Собирает данные для отправки
     * @return {FormData} - formData
     * @private
     */
    _collectData() {
        const formData = new FormData();
        const options = this.select?.getOptions() || null;
        const activeSelect = options?.find((item) => {
            return item.checked;
        }) || null;
        const search = this.inputSearch?.value.trim() || null;

        this.tags.forEach((tag) => {
            if (!tag.checked) {
                return;
            }
            formData.append('tags[]', tag.value);
        });

        formData.append('page_num', this.pageNum);

        if (!this.promotion) {
            formData.append('select', activeSelect?.value);
        }

        if (search) {
            formData.append('search', search);
        }

        return formData;
    }

    /**
     * Устанавливает данные в шаблон
     * @private
     */
    _setTemplateData() {
        const {
            items,
            page_num: pageNum = 2,
            more = false,
            count
        } = this.newsData;

        // если подгружаем доп. элементы, выводим их во вторую часть страницы
        // иначе если элементов больше одной страницы, то делим массив на 2 части
        // иначе выводим все элементы в первой части страницы
        if (this.isLoadMore) {
            this._updatePage(this.promotion ? this.listWrapperFirst : this.listWrapperSecond, items, false);
            if (!this.promotion) {
                this._changeStateSecondListWrapper(true);
            }
        } else if (items.length >= this.maxShow && more) {
            this._updatePage(this.listWrapperFirst, items.slice(0, 6));

            if (!this.promotion) {
                this._updatePage(this.listWrapperSecond, items.slice(6, 12));
                this._changeStateSecondListWrapper(true);
            }
        } else {
            this._updatePage(this.listWrapperFirst, items);

            if (!this.promotion) {
                this._changeStateSecondListWrapper(false);
            }
        }

        this._updateMoreButton(more, count);
        this.pageNum = String(pageNum);
    }

    /**
     * Обновляет данные на странице
     * @param {object} container - контейнер куда выводим
     * @param {object} data - данные для вывода
     * @param {boolean} isClear - очищаем ли всё в контейнере
     * @private
     */
    _updatePage(container, data, isClear = true) {
        if (isClear) {
            Utils.clearHtml(container);
        }

        Utils.insetContent(container, this.template({
            items: data
        }));
        observer.publish('lazyLoad:refresh', container);
    }

    /**
     * Скрывает/показывает вторую часть страница
     * @param {boolean} show - показать/скрыть блок
     * @private
     */
    _changeStateSecondListWrapper(show) {
        const method = show ? 'remove' : 'add';

        this.listWrapperSecond.classList[method]('is-hide');
    }

    /**
     * Изменяем состояние кнопка "подгрузить ещё"
     * @param {boolean} more - показать/скрыть блок
     * @param {number|string} count - сколько элементов можно ещё подгрузить
     * @private
     */
    _updateMoreButton(more, count = 0) {
        if (!this.moreButton) {
            return;
        }

        const method = more ? 'remove' : 'add';

        this.moreButton.classList[method]('is-hide');
        this.moreButton.innerText = `Показать ещё ${count}`;
    }

    /**
     * Переключает лоадер вкл
     * @private
     */
    _startLoading() {
        this.contentWrapper.classList.add(this.loadingClass);
    }

    /**
     * Переключает лоадер выкл
     * @private
     */
    _endLoading() {
        this.contentWrapper.classList.remove(this.loadingClass);
    }

    /**
     * Блокирует нажатия по тегам во время подгрузки данных
     * @private
     */
    _disabledTags() {
        if (!this.tagsWrapper) {
            return;
        }

        this.tagsWrapper.classList.add('is-disabled');
    }

    /**
     * Разблокирует нажатия по тегам после подгрузки данных
     * @private
     */
    _enabledTags() {
        if (!this.tagsWrapper) {
            return;
        }

        this.tagsWrapper.classList.remove('is-disabled');
    }
}

export default NewsList;
